import { FORMA_PAGO_TYPES } from "../constants/forma-pago..types";
import { ActionFP, FormaPago } from "../interfaces/forma-pago.interface";

const initialState: FormaPago = {
    formFormaPago: {
        condicion: '1',
        formaPago: '01',
        monto: '',
        plazo: '',
        numeroDocumento: '',
        periodo: '',
    },
    errorsFormaPago: {
        condicion: '',
        formaPago: '',
        monto: '',
        plazo: '',
        numeroDocumento: '',
        periodo: '',
    },

    totalAPagar: '',
    pagos: [],
    tablePagos: [],

    modal_error: false,
    pagoCompletado: false
}

const formaPagoReducer = (state: FormaPago = initialState, action: ActionFP): FormaPago => {
    switch(action.type){
        case FORMA_PAGO_TYPES.FP_HANDLE_CHANGE_FORM:
            return {...state, formFormaPago: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_ERRORS_FORM:
            return {...state, errorsFormaPago: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_SET_PAGOS:
            return {...state, pagos: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_SET_TOTAL_A_PAGAR:
            return {...state, totalAPagar: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_ACTIVE_MODAL_ERROR:
            return {...state, modal_error: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_SET_TABLE_PAGOS:
            return {...state, tablePagos: action.payload}
        case FORMA_PAGO_TYPES.FP_HANDLE_SET_PAGO_COMPLETADO:
            return {...state, pagoCompletado: action.payload}
        case FORMA_PAGO_TYPES.FP_RESTART_STATE:
            return {...initialState, pagos: [], tablePagos: []}
        default: return state
    }
}

export default formaPagoReducer